<template>
    <div class="shop__equipment-picker">
        <div class="shop__equipment-row" v-show="ShowDropdown">
            <SelectWithLabel :label="Strings['Shop.LabelPickEquipment']" v-model="SelectedEquipmentId" rules="required" :options="AvailableEquipmentsOptions" />
        </div>
        <div class="shop__equipment-row" v-if="ShowQuantity && CurrentEquipment !== null && SelectedEquipmentId == -1">
            <InputWithLabel :label="Texts.QuantityText"
                            :value="CurrentEquipment.quantity"
                            @change="newVal => CurrentEquipment.$update({ quantity: newVal })"
                            rules="required"
                            cssclass="migrol-form__input-wrapper--medium"
                            :postfix="Texts.QuantityUnits"
                             />
        </div>
        <div class="shop__equipment-row" v-if="CurrentEquipment !== null && SelectedEquipmentId == -1">
            <InputWithLabel :label="Texts.SizeText"
                            :value="CurrentEquipment.size"
                            @change="newVal => CurrentEquipment.$update({ size: newVal })"
                            rules="required"
                            cssclass="migrol-form__input-wrapper--medium"
                            :postfix="Texts.SizeUnits"
                             />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { EquipmentSource } from '@/utils/constants';
    import { mapFilters } from '@/utils/vueFilters';
    import Position from '@/models/Position';
    import Equipment from '@/models/Equipment';

    export default {
        data() {
            return {
                SelectedEquipmentId: '',
                CustomEquipmentId: -1
            }
        },
        computed: {
            ...mapState([
                'Strings',
                'Product'
            ]),
            AvailableEquipments() {
                return Equipment.query().where('equipmentSource', EquipmentSource.ServerEquipment).get();
            },
            AvailableEquipmentsOptions() {
                let options = this.AvailableEquipments.map((eq) => {
                    if (this.ShowQuantity) {
                        return {
                            id: eq.id,
                            text: `${this.Texts.QuantityText}: ${this.formatAmount(eq.quantity)}, ${this.Texts.SizeText}: ${this.formatAmount(eq.size)} ${this.Texts.SizeUnits}`
                        }
                    } else {
                        return {
                            id: eq.id,
                            text: `${this.Texts.SizeText}: ${this.formatAmount(eq.size)} ${this.Texts.SizeUnits}`
                        }
                    }
                });
                options.push({ text: this.Strings['Shop.OptionOtherEquipment'], id: '-1' }); //add "other" choice

                return options;
            },
            Texts() {
                switch (this.Product) {
                    case 'Tankrevision':
                        return {
                            SizeUnits: this.Strings['Shop.UnitsLiter'],
                            QuantityUnits: this.Strings['Shop.EquipmentType_Tanks'],
                            QuantityText: this.Strings['Shop.LabelNumberOfTanks'],
                            SizeText: this.Strings['Shop.LabelSingleTankSize']
                        }
                    case 'Boilerentkalkung':
                        return {
                            SizeUnits: this.Strings['Shop.UnitsLiter'],
                            SizeText: this.Strings['Shop.LabelBoilerSize']
                        }
                }

                return null;
            },
            ShowQuantity() {
                switch (this.Product) {
                    case 'Tankrevision':
                        return true;
                    case 'Boilerentkalkung':
                        return false;
                    default:
                        return null;
                }
            },
            CurrentPosition() {
                return Position.query().with('equipment').first();
            },
            CurrentEquipment() {
                return this.CurrentPosition.equipment;
            },
            //CurrentEquipmentEditable() {
            //    return this.CurrentEquipment != null && this.CurrentEquipment.equipmentSource === EquipmentSource.ManualEquipment;
            //},
            ShowDropdown() {
                return this.AvailableEquipments.length > 0;
                //if (this.AvailableEquipments.length > 1) {
                //    return true;
                //}
                //else if (this.AvailableEquipments.length === 1 && this.CurrentEquipment !== null && this.CurrentEquipment.id !== this.AvailableEquipments[0].id) {
                //    return true;
                //} else {
                //    return false;
                //}
            }
        },
        watch: {
            SelectedEquipmentId: {
                immediate: true,
                handler(newEquipmentId) {
                    let vm = this;

                    if (newEquipmentId === '-1') {
                        //user selected "other" from the dropdown -> create a blank equipment
                        if (vm.CustomEquipmentId === -1) {
                            Equipment.new().then((newEquipment) => {
                                //update position to use the new equipment
                                Position.update({
                                    id: vm.CurrentPosition.id,
                                    equipment: newEquipment
                                }).then(() => {
                                    vm.CustomEquipmentId = newEquipment.id;
                                });
                            });
                        } else {
                            //set custom equipment
                            Position.update({
                                id: vm.CurrentPosition.id,
                                equipment: Equipment.find(vm.CustomEquipmentId)
                            });
                        }
                    } else {
                        //set server equipment
                        Position.update({
                            id: vm.CurrentPosition.id,
                            equipment: Equipment.find(newEquipmentId)
                        });
                    }
                }
            }
        },
        methods: {
            ...mapFilters(['formatAmount']),
            fixEquipment() {
                if (this.CustomEquipmentId === -1) {
                    Equipment.insert({
                        data: {
                            quantity: this.CurrentEquipment.quantity,
                            size: this.CurrentEquipment.size
                        }
                    }).then((result) => {
                        this.CustomEquipmentId = result.equipments[0].id;
                        this.SelectedEquipmentId = '-1';
                    });
                } else {
                    Equipment.update({
                        id: this.CustomEquipmentId,
                        quantity: this.CurrentEquipment.quantity,
                        size: this.CurrentEquipment.size
                    }).then(() => {
                        this.SelectedEquipmentId = '-1';
                    });
                }
            }
        },
        mounted() {
            if (this.AvailableEquipments.length > 1 && this.CurrentEquipment !== null) {
                if (this.AvailableEquipments.map((eq) => { return eq.id }).includes(this.CurrentEquipment.id)) {
                    this.SelectedEquipmentId = this.CurrentEquipment.id;
                } else {
                    this.CustomEquipmentId = this.CurrentEquipment.id;
                    this.SelectedEquipmentId = '-1';
                }
            } else if (this.AvailableEquipments.length === 1) {
                if (this.CurrentEquipment !== null) {
                    if (this.AvailableEquipments[0].id === this.CurrentEquipment.id) {
                        //an equipment is selected and its ID matches
                        this.SelectedEquipmentId = this.CurrentEquipment.id;
                    } else {
                        //an "unknown" equipment is selected
                        this.CustomEquipmentId = this.CurrentEquipment.id;
                        this.SelectedEquipmentId = '-1';
                    }
                } else {
                    //only 1 equipment available and current equipment is null -> auto-pick the available equipment
                    this.SelectedEquipmentId = this.AvailableEquipments[0].id;
                }
            } else if (this.AvailableEquipments.length === 0) {
                if (this.CurrentEquipment !== null) {
                    this.CustomEquipmentId = this.CurrentEquipment.id;
                    this.SelectedEquipmentId = '-1';
                } else {
                    //create new empty equipment
                    Equipment.new().then((newEquipment) => {
                        this.CustomEquipmentId = newEquipment.id;
                        this.SelectedEquipmentId = '-1';
                    });
                }
            }
        },
        components: {
            
        }
    };
</script>